import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { QueryConfig } from '@/lib/tanstack-query';
import { SalesRound } from '@/types/api/sale';

export const listSalesRound = async ({}: {}): Promise<SalesRound[]> => {
  return (await api.get(`/sales-rounds`)).data;
};

export const listSalesRoundQueryOptions = () => {
  return queryOptions({
    queryKey: ['sales-rounds'],
    queryFn: () => listSalesRound({}),
    // enabled: Boolean(_),
  });
};

type UseSalesRoundsOptions = {
  queryConfig?: QueryConfig<typeof listSalesRoundQueryOptions>;
};

export const useSalesRounds = ({ queryConfig }: UseSalesRoundsOptions) => {
  return useQuery({
    ...listSalesRoundQueryOptions(),
    ...queryConfig,
  });
};

export const useSalesRoundsSuspense = ({ queryConfig }: UseSalesRoundsOptions) => {
  return useSuspenseQuery({
    ...listSalesRoundQueryOptions(),
    ...queryConfig,
  });
};
